"use client";
// https://posthog.com/docs/libraries/next-js
import { env } from "@/env";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

if (typeof window !== "undefined") {
  posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: "/api/ingest",
    ui_host: "https://us.posthog.com", // or 'https://eu.posthog.com' if your PostHog is hosted in Europe
    capture_pageview: false, // Disable automatic pageview capture, as we capture manually
    autocapture: false, // too expensive
  });
}

export function PHProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
